"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7437],{

/***/ 67437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v1_MegaMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/constant.js
var constant = __webpack_require__(59187);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/MegaMenu/analytics.js

const getUserMenuFragmentEventInfo = function() {
    let textContent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", themeChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    if (!themeChange) {
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "my account:".concat(textContent),
            eventMsg: "n/a",
            eventName: "my account:".concat(textContent),
            eventStatus: "n/a",
            eventType: constant/* GLOBAL_HEADER_TEXT */.A,
            internalLinkName: textContent,
            internalLinkPosition: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, " ").concat(textContent),
            internalLinkType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":navigation"),
            internalLinkURL: "n/a",
            internalLinkZoneName: constant/* GLOBAL_HEADER_TEXT */.A
        });
    } else {
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":").concat(textContent),
            eventName: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":").concat(textContent),
            eventType: "navigation",
            internalLinkName: textContent,
            internalLinkPosition: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":").concat(textContent),
            internalLinkType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":mega menu navigation"),
            internalLinkURL: link ? link : "n/a",
            internalLinkZoneName: constant/* GLOBAL_HEADER_TEXT */.A
        });
    }
};

// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(30394);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/MegaMenu/index.js








// const isMobile =
//   window.outerWidth === 0
//     ? window.innerWidth <= 1200
//     : isSafari
//     ? window.innerWidth <= 1200
//     : window.outerWidth <= 1200
const MegaMenu = (props)=>{
    const { userMenuFragment , guestMenuFragment , isLoggedIn , i18n , user , logout , toggleAuthNav , handleSignin , handleCreateAccount , onAuthMenuClick  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const signOutEventInfo = JSON.stringify({
        eventName: "my account:sign out",
        eventAction: "my account:sign out",
        internalLinkName: "sign out",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: window.location.origin + "/en",
        internalLinkPosition: "global header sign out",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    const leftArrow = "/icons/left-arrow-white.svg";
    const iconCloseMedium = "/icons/close-medium.svg";
    const iconUserSignin = "/icons/user-signin.svg";
    const name = user && (user === null || user === void 0 ? void 0 : user.firstName);
    const modalWindow = (0,react.useRef)(null);
    const handleKeyPress = ()=>{
        if (userMenuFragment) {
            addAnalyticsUserMenuFragment();
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("click", handleKeyPress);
        modalWindow.current.focus();
        if (userMenuFragment) {
            addAnalyticsUserMenuFragment();
        }
        return ()=>{
            window.removeEventListener("click", handleKeyPress);
        };
    });
    const addAnalyticsUserMenuFragment = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll("p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const eventInfo = getUserMenuFragmentEventInfo(textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), themeChange, link === null || link === void 0 ? void 0 : link.href);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
        });
    };
    const capitalizeFirstName = (firstname)=>{
        firstname = (firstname === null || firstname === void 0 ? void 0 : firstname.charAt(0).toUpperCase()) + (firstname === null || firstname === void 0 ? void 0 : firstname.slice(1));
        return firstname;
    };
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,genericSlice/* closeMenu */.Wj)());
        } else {
            dispatch((0,genericSlice/* openMenu */.qn)());
        }
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container kf-react-container",
        children: [
            lib/* isMobile */.tq && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                tabIndex: "0",
                role: "button",
                id: "auth-nav__menu-mobile-back",
                className: "auth-nav__menu-mobile-back-menu",
                onClick: ()=>{
                    toggleAuthNav();
                    onAuthMenuClick(false);
                    (0,helper/* toggeleBodyClass */.wMR)(false);
                },
                children: [
                    themeChange ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: leftArrow,
                        alt: i18n.leftArrowAlt
                    }),
                    themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(i18n.hi, " ").concat(capitalizeFirstName(user === null || user === void 0 ? void 0 : user.firstName))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(i18n.menu)
                    }),
                    themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                        "aria-label": "close button",
                        tabIndex: "0",
                        onClick: ()=>{
                            toggleMenu();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: iconCloseMedium,
                            alt: ""
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "auth-nav__menu-wrap",
                className: "auth-nav__menu-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "auth-nav__menu-title",
                        children: isLoggedIn ? "".concat(i18n.welcome, " ").concat(name, "!") : i18n.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "auth-nav__menu-items",
                        role: "list",
                        children: [
                            !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                role: "list-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        name: "signin",
                                        id: "kf-react-sign-in",
                                        onClick: handleSignin,
                                        className: "gbh-data-layer",
                                        children: [
                                            themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: iconUserSignin,
                                                alt: ""
                                            }) : null,
                                            i18n.signIn
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                role: "list-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        className: "gbh-data-layer",
                                        id: "kf-react-sign-up",
                                        name: "create-account",
                                        onClick: handleCreateAccount,
                                        children: [
                                            themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: iconUserSignin,
                                                alt: ""
                                            }) : null,
                                            i18n.createAccount
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "list-item",
                                "data-gbh-data-layer": addAnalyticsUserMenuFragment,
                                ref: modalWindow,
                                onClick: handleKeyPress,
                                className: "order-status-signin",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(isLoggedIn ? userMenuFragment : guestMenuFragment !== null && guestMenuFragment !== void 0 ? guestMenuFragment : null)
                            }),
                            isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "sign-out",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        onClick: logout,
                                        className: "gbh-data-layer",
                                        "data-gbh-data-layer": signOutEventInfo,
                                        children: i18n.logout
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_MegaMenu = (MegaMenu);


/***/ })

}]);